import { instance } from '@/utils/http.js'

// 答案解析/做题详情-反馈  
export const topicPress = (data) => {
  return instance({
    url: '/api/v1/error/report',
    method: 'post',
    data
  })
}